import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupScreenRecordingWarningContentProps } from './msg-group-screen-recording-warning-content';
import { MsgGroupScreenRecordingWarningContent } from './msg-group-screen-recording-warning-content';

export interface MsgGroupScreenRecordingWarningPreviewProps
  extends MsgGroupScreenRecordingWarningContentProps {}

export const MsgGroupScreenRecordingWarningPreview = memo(
  function MsgGroupScreenRecordingWarningPreview({
    message,
  }: MsgGroupScreenRecordingWarningPreviewProps) {
    return (
      <LastMessageSystem>
        <MsgGroupScreenRecordingWarningContent message={message} />
      </LastMessageSystem>
    );
  }
);
